import React from 'react';
import { MapPin, Wine, Palmtree, Castle, Navigation } from 'lucide-react';
import { useLanguage } from '../contexts/LanguageContext';

export const Location = () => {
  const { t } = useLanguage();
  const nearby = t('location.nearby');
  const nearbyIcons = [Wine, Palmtree, Castle, Navigation, Castle];

  return (
    <section className="location-section">
      <div className="container-custom">
        <div className="text-center mb-12">
          <div className="section-badge">{t('location.badge')}</div>
          <h2 className="section-title">{t('location.title')}</h2>
          <p className="section-description">{t('location.description')}</p>
        </div>

        <div className="location-map-container">
          <div className="location-address-bar">
            <a
              href="https://www.google.com/maps?q=45.334431,13.734886"
              target="_blank"
              rel="noopener noreferrer"
              className="location-address-link"
              data-testid="location-address-link"
            >
              <MapPin className="h-5 w-5" />
              <span>Bajkini 6F, 52447 Bajkini (Vižinada), Istria, Croatia</span>
            </a>
          </div>
          <iframe
            src="https://maps.google.com/maps?q=45.334431,13.734886&z=15&ie=UTF8&iwloc=&output=embed"
            width="100%"
            height="450"
            style={{ border: 0, borderRadius: '0 0 16px 16px' }}
            allowFullScreen=""
            loading="lazy"
            referrerPolicy="no-referrer-when-downgrade"
            title="Villa in Pietra Location - Bajkini, Istria"
          ></iframe>
        </div>

        <div className="location-grid">
          <div className="location-content">
            <p className="location-description">
              {t('location.description')}
            </p>

            <div className="nearby-list">
              <h3 className="nearby-title">{t('location.nearbyTitle')}</h3>
              <div className="nearby-items">
                {Array.isArray(nearby) && nearby.map((item, index) => {
                  const IconComponent = nearbyIcons[index];
                  return (
                    <div key={index} className="nearby-item">
                      <div className="nearby-icon">
                        <IconComponent className="h-5 w-5" />
                      </div>
                      <div className="nearby-info">
                        <span className="nearby-name">{item.name}</span>
                        <span className="nearby-distance">{item.distance}</span>
                      </div>
                    </div>
                  );
                })}
              </div>
            </div>
          </div>

          <div className="location-visual">
            <div className="location-image-wrapper">
              <img
                src="/villa-images/zalazak-8.jpg"
                alt="Aerial view of Villa in Pietra estate"
              />
              <div className="location-badge">
                <MapPin className="h-4 w-4" />
                <span>Bajkini, Istria</span>
              </div>
            </div>

            <div className="location-features">
              <div className="location-feature-item">
                <Wine className="h-6 w-6 text-imperial-red" />
                <div>
                  <h4>{t('location.wineTourism')}</h4>
                  <p>{t('location.wineDesc')}</p>
                </div>
              </div>
              <div className="location-feature-item">
                <Castle className="h-6 w-6 text-imperial-red" />
                <div>
                  <h4>{t('location.medievalTowns')}</h4>
                  <p>{t('location.medievalDesc')}</p>
                </div>
              </div>
              <div className="location-feature-item">
                <Palmtree className="h-6 w-6 text-imperial-red" />
                <div>
                  <h4>{t('location.coastalAccess')}</h4>
                  <p>{t('location.coastalDesc')}</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
